import styled from '@emotion/styled'

const Wrapper = styled('div')(({ theme: { space, mediaQueries } }) => ({
  margin: `${space.large} 0`,

  '[data-network="whatsapp"], [data-network="messenger"]': {
    [mediaQueries.small]: {
      display: 'none !important',
    },
  },
}))

export default Wrapper
